import { IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { IOfferPinSchema } from '../../../repositories/favorites/entities/user_folder/OfferPinSchema';
import { selectActivePin, selectMapData } from '../../../selectors';
import { EType, TInfrastructurePin } from '../../../types/map';
import { INFRASTRUCTURE_MAIN } from '../MapContainer';
import { getGeoObject, setPriceColor } from '../utils';

const INFRASTRUCTURE_TYPES = [
  {
    title: 'Метро',
    type: EType.Metro,
  },
  {
    title: 'Школы',
    type: EType.School,
  },
  {
    title: 'Детские сады',
    type: EType.Nursery,
  },
  {
    title: 'Поликлиники',
    type: EType.Clinic,
  },
  {
    title: 'Магазины',
    type: EType.Grocery,
  },
];

export const useGeoObjects = () => {
  const infrastructureItemsRef = React.useRef(new Map<string, TInfrastructurePin>());

  const { offerPins, infrastructurePins } = useSelector(selectMapData);
  const activePin = useSelector(selectActivePin);

  const mapInfrastructure = React.useCallback((item: TInfrastructurePin) => {
    const { type, coordinates, id } = item;
    infrastructureItemsRef.current.set(id, item);

    return getGeoObject({ name: type, coordinates, id });
  }, []);

  const mapOffers = React.useCallback(
    ({ coordinates, price, realtyOfferId }: IOfferPinSchema) => {
      return getGeoObject({
        name: INFRASTRUCTURE_MAIN,
        coordinates,
        price,
        id: realtyOfferId.toString(),
        active: realtyOfferId === activePin,
      });
    },
    [activePin],
  );

  React.useEffect(() => {
    offerPins.forEach(({ realtyOfferId }) => {
      setPriceColor(realtyOfferId, activePin);
    });
  }, [activePin, offerPins]);

  const handleGeoObjectsFirstFetch = async (): Promise<IGeoObject[]> => {
    if (!infrastructureItemsRef.current.size) {
      const offersGeoTags = offerPins.map(mapOffers);
      const infrastructureGeoTags = infrastructurePins.map(mapInfrastructure);

      return Promise.resolve([...infrastructureGeoTags, ...offersGeoTags]);
    }

    return Promise.resolve([]);
  };

  return {
    infrastructureItemsRef,
    infrastructureTypes: INFRASTRUCTURE_TYPES,
    onGeoObjectsFirstFetch: handleGeoObjectsFirstFetch,
  };
};
